export enum timezonesEnum {
  AMERICA_NEW_YORK = 'America/New_York',
  AMERICA_LOS_ANGELES = 'America/Los_Angeles',
  AMERICA_PHOENIX = 'America/Phoenix',
  AMERICA_CHICAGO = 'America/Chicago',
  UTC = 'UTC',
  EUROPE_WARSAW = 'Europe/Warsaw',
  // one timezone for each 1hr diff
  EUROPE_LISBON = 'Europe/Lisbon',
  EUROPE_DUBLIN = 'Europe/Dublin',
  AFRICA_CASABLANCA = 'Africa/Casablanca',
  EUROPE_LONDON = 'Europe/London',
  EUROPE_PARIS = 'Europe/Paris',
  EUROPE_ATHENS = 'Europe/Athens',
  ASIA_DUBAI = 'Asia/Dubai',
  ASIA_KARACHI = 'Asia/Karachi',
  ASIA_DHAKA = 'Asia/Dhaka',
  ASIA_BANGKOK = 'Asia/Bangkok',
  ASIA_KUALA_LUMPUR = 'Asia/Kuala_Lumpur',
  ASIA_TOKYO = 'Asia/Tokyo',
  AUSTRALIA_SYDNEY = 'Australia/Sydney',
  PACIFIC_AUCKLAND = 'Pacific/Auckland',
}

export const timezones = Object.values(timezonesEnum);

export const timeZoneDate = (timezone: timezonesEnum | string, initDate?: Date) => {
  const init = initDate ?? new Date();
  const date = new Date(
    Date.UTC(init.getFullYear(), init.getMonth(), init.getDate(), init.getHours(), init.getMinutes(), init.getSeconds()),
  );

  const utcDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }));
  const tzDate = new Date(date.toLocaleString('en-US', { timeZone: timezone }));
  const offset = utcDate.getTime() - tzDate.getTime();

  date.setTime(date.getTime() + offset);

  return date;
};
